import { createFileRoute } from "@tanstack/react-router";
import { StoragePage } from "@/features/filesmore/StoragePage";

export const Route = createFileRoute("/_app/files/storage")({
  component: StoragePage,
});
